import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const AbnormalBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-purple-600 text-white">
      {t('component:badge.abnormal')}
    </Badge>
  );
};
